import React from 'react';
import { PickerButton, BoundsButton } from './OptionPicker';

// The value widget of a condition row. Tags and sites use dialog pickers
// (option list / map region); everything else is a plain input/select.
export default function ConditionValues({
  field,
  op,
  condition,
  onChange,
  onPickOptions,
  onPickRegion
}) {
  if (op === 'between') {
    return (
      <>
        {['min', 'max'].map((k) => (
          <input
            key={k}
            className={`condition-${k}`}
            type="number"
            value={condition[k] || ''}
            placeholder={k}
            onChange={(e) => onChange({ ...condition, [k]: e.target.value })}
          />
        ))}
      </>
    );
  }
  if (op === 'is_null' || op === 'is_not_null') return null;
  if (field && field.kind === 'tags') {
    return (
      <PickerButton
        noun="tags"
        options={field.options}
        values={condition.values}
        onPick={onPickOptions}
      />
    );
  }
  if (field && field.kind === 'sites') {
    return op === 'within_bbox' ? (
      <BoundsButton values={condition.values} onPick={onPickRegion} />
    ) : (
      <PickerButton
        noun="sites"
        options={field.options}
        values={condition.values}
        onPick={onPickOptions}
      />
    );
  }
  if (op === 'in') {
    const options = field && field.options;
    // Options are { value, label } objects; fall back to the current scalar
    // value so the selection still shows something when no options loaded.
    const items =
      options ||
      (condition.value != null ? [{ value: condition.value, label: String(condition.value) }] : []);
    return (
      <select
        className="condition-values"
        multiple
        value={condition.values || []}
        onChange={(e) =>
          onChange({ ...condition, values: [...e.target.selectedOptions].map((o) => o.value) })
        }
      >
        {items.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    );
  }
  // eq: pick from the options when the field has them, free input otherwise
  const kind = field ? field.kind : 'text';
  const options = field && field.options;
  if (options && options.length > 0) {
    return (
      <select
        className="condition-value"
        value={condition.value || ''}
        onChange={(e) => onChange({ ...condition, value: e.target.value })}
      >
        <option value="">value…</option>
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    );
  }
  return (
    <input
      className="condition-value"
      type={kind === 'numeric' || kind === 'angle' ? 'number' : 'text'}
      value={condition.value || ''}
      placeholder={kind === 'boolean' ? 'true/false' : 'value'}
      onChange={(e) => onChange({ ...condition, value: e.target.value })}
    />
  );
}
